import { createContext, useContext } from "react";
import type { AppDatabase } from "./db/database";

/**
 * Application-wide context giving workspaces access to the repositories.
 * UI components never touch SQL directly — only repository methods.
 */
export const AppDbContext = createContext<AppDatabase | null>(null);

export function useAppDb(): AppDatabase {
  const ctx = useContext(AppDbContext);
  if (!ctx) {
    throw new Error("useAppDb must be used inside AppDbContext.Provider");
  }
  return ctx;
}

/**
 * WHO IS LOOKING AT THIS PROJECT (spec §71C).
 *
 * "owner" is the default everywhere — the ordinary workspace never thinks
 * about it. A shared project provides "design-collaborator", and the tabs
 * use `useIsProjectOwner()` to put the owner-only controls away. This is
 * PRESENTATION ONLY: the server's allowlist refuses a collaborator's write
 * whatever the UI shows, and the roles here deliberately leave room for
 * more than two later.
 */
export type ProjectRole = "owner" | "design-collaborator";

export const ProjectRoleContext = createContext<ProjectRole>("owner");

export function useProjectRole(): ProjectRole {
  return useContext(ProjectRoleContext);
}

export function useIsProjectOwner(): boolean {
  return useContext(ProjectRoleContext) === "owner";
}
